
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"#1f1f1f"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M560-240L320-480l240-240 56 56-184 184 184 184-56 56z"}})])
          )
        }
      }
    